/**
 * Conditional logging utility for consent-related operations
 *
 * Logs are only shown in development environments to avoid cluttering
 * production console output while maintaining visibility during development.
 */

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * Logger for consent-related operations
 * - log: Only shown in development
 * - warn: Always shown (important for debugging issues)
 * - error: Always shown (critical issues)
 */
export const consentLogger = {
  /**
   * Log informational messages (development only)
   */
  log: (...args: unknown[]) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.log('[Polaris Consent]', ...args);
    }
  },

  /**
   * Log warning messages (always shown)
   */
  warn: (...args: unknown[]) => {
    // eslint-disable-next-line no-console
    console.warn('[Polaris Consent]', ...args);
  },

  /**
   * Log error messages (always shown)
   */
  error: (...args: unknown[]) => {
    // eslint-disable-next-line no-console
    console.error('[Polaris Consent]', ...args);
  },
};
